import { Component, OnInit } from '@angular/core';
import { ScheduleService,MasterService,HrmsService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-year-calender',
  templateUrl: './year-calender.component.html',
  styleUrls: ['./year-calender.component.scss'],
  providers:[ScheduleService,MasterService,HrmsService]
})
export class YearCalenderComponent implements OnInit {
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;

  arrsch:any=[];
  masocc=[];
  objfilt:any={};
    objsch:any={};
    arrasch:any=[];
    arremp:any=[];
    serchtxt='';
    ftype="ALL";

  constructor(private http: HttpClient, private sservice: ScheduleService,private mservice:MasterService,private hservice:HrmsService,private modalService: NgbModal) { }

  open(content) {
    this.modalOptions = {
     
      size:'md'
     
    }
    
    this.modalService.open(content, this.modalOptions ).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
 
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {

    // this.Bindtable();
    //this.Getsel_sp_masoccation();
    this.sel_schyearcalendar();
    this.getstaff();
  }


  Getsel_sp_masoccation()
  {
    debugger
    this.mservice.sel_sp_masoccation()
    .subscribe(
    resultArray =>{
    console.log('result',resultArray) ;
    this.masocc=resultArray;
    
      },
  error => console.log("Error :: " + error)
  )
  }
  Bindtable() {
      debugger
      
      
      this.sservice.sel_sp_schyearlycalendar()
          .subscribe(resultArray => {
             console.log('ret-select', resultArray);
              this.arrsch = resultArray;
              //alert (resultArray.message);

          }, error =>
              alert('error in connection')
          );
      
  }

  exportrecord(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
    // if(txt=="")
    // {

    // }
     //var url=this.liservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
     var url=this.sservice.callurl+"export/expyearcalender.php?clcd="+clcd+"&aycd="+aycd+"&sertxt="+this.serchtxt+"&tag="+this.ftype;
  
     window.open(url,'','');
   }

  sel_schyearcalendar() {
    debugger
    
    
    this.sservice.sel_schyearcalendar(this.ftype)
        .subscribe(resultArray => {
           console.log('ret-select', resultArray);
            this.arrsch = resultArray;
            //alert (resultArray.message);

        }, error =>
            alert('error in connection')
        );
    
}


getstaff() {
  this.hservice.getemployes()
      .subscribe(
      resultArray => {
          console.log('getlibdepartment', resultArray);
         
        var activeemps   = resultArray.emplst.filter(function(arr)
          {
      
            return arr.emstatus=='Active';
          });
          this.arremp= activeemps.map( o => { return { emid: o.emid, emnm: o.emnm} });
         
          
      },
      error => console.log("Error :: " + error)
      )
}

  opensubject(content) {
   
      this.objsch={};
     
      
      //console.log('date',this.sservice.getdatetoday().toString())
      this.objsch.occid=0;
      //this.objsch.subgpId=0;
      this.objsch.frdt=this.sservice.getdatetoday();
      this.objsch.todt=this.sservice.getdatetoday();
 
     
  
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
      
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  deleteschedule(obj,oprtype) {
    if(confirm("Are you sure you ? you want to delete"))
    {this.save_schyearcalendar(obj,oprtype);
    }
  }

  save_schyearcalendar(obj,oprtype) {
    

    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    let usid=localStorage.getItem('usid');
   // let holdt=this.SchService.converttodate(hodt);
   // var oprtag = "insert"
   var clssubdata = { rid:obj.rid, ydt: obj.ydt,dayrmk:obj.dayrmk, oprtype:oprtype,clcd:clcd,aycd:aycd,emid:obj.emid ,usid:usid,schtype:obj.schtype};
    
    
   
    console.log('save-model', clssubdata);
    this.sservice.save_schyearcalendar(clssubdata)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            
            this.sel_schyearcalendar();
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();
  }


  gen_schyearcalendar(obj) {
    

    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    let usid=localStorage.getItem('usid');
   // let holdt=this.SchService.converttodate(hodt);
   // var oprtag = "insert"
   var clssubdata = { frdt: obj.frdt,todt:obj.todt,clcd:clcd,aycd:aycd,usid:usid};
    
    
   
    console.log('save-model', clssubdata);
    this.sservice.gen_schyearcalendar(clssubdata)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            
            if(resultArray.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
             // this.Getsel_sp_massubgp();
            // this.Bindtable();
            this.sel_schyearcalendar();
            }
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();
  }
  SaveDetails() {
    var occid = this.objsch.occid;
    var ycdtfrom = this.objsch.ycdtfrom;
    var ycdtto = this.objsch.ycdtto;

    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
   // let holdt=this.SchService.converttodate(hodt);
   // var oprtag = "insert"
   var clssubdata = { occid: occid, ycdtfrom: ycdtfrom,ycdtto:ycdtto, oprtag:  this.objsch.oprtype,clcd:clcd,aycd:aycd };
   //var clssubdata = { occid: occid, hodt: hodt, oprtag: this.objsch.oprtype,clcd:clcd,aycd:aycd };
   // var oprtag = "insert"
    //var clssubdata = { clid: clid, subid: subid, oprtag: this.objsch.oprtype,assid:assid,asstypeid:asstypeid,portion:portion,remarks:remarks,assdt:assdt,clcd:clcd,aycd:aycd };
    
    
   
    console.log('save-model', clssubdata);
    this.sservice.save_sp_schyearlycalendar(clssubdata)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            if(resultArray.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
             // this.Getsel_sp_massubgp();
            // this.Bindtable();
            }
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();
  }
}
